import { DefaultEffects, IconButton, Label } from "@fluentui/react";
import React from "react";
import { IPropiedadesPorGrupo } from "../../../Interfaces/ListaVerificacion/PropiedadesVerificacion/IPropiedadesVerificacion";
interface IPlantillaPreViewGrupo {
  data: IPropiedadesPorGrupo;
  indice: number;
}
export const PlantillaPreViewGrupo = (props: IPlantillaPreViewGrupo) => {
  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        {props.data?.grupoName && (
          <div
            id="Cabecerra"
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "auto",
              backgroundColor: "#979593",
              alignItems: "end",
              boxShadow: DefaultEffects.elevation64,
            }}
          >
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg10">
              <Label
                styles={{
                  root: {
                    color: "White",
                    fontSize: "14px",
                    padding: "5px",
                    fontFamily: "Monaco, Menlo, Consolas",
                  },
                }}
              >
                {props.data?.grupoName}
              </Label>
            </div>
            <div
              className="ms-Grid-col ms-sm12 ms-md6 ms-lg2"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Label
                styles={{
                  root: {
                    color: "White",
                    fontSize: "16px",
                    padding: "5px",
                    fontFamily: "Monaco, Menlo, Consolas",
                  },
                }}
              >
                {props?.indice}
              </Label>
            </div>
          </div>
        )}

        {props.data?.propiedades.map((item, i) => (
          <div
            id="registros"
            className="ms-Grid-row"
            style={{
              display: "flex",
              border: "0.5px solid #b3b0ad",
              flexDirection: "row",
              backgroundColor: "#faf9f8",
              height: "auto",
              alignItems: "end",
            }}
          >
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg12">
              <Label style={{fontSize:"11px"}}> {item?.text}</Label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
